import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, vModelText as _vModelText } from "vue";
const _hoisted_1 = {
  key: 0,
  class: "shadowTop"
};
const _hoisted_2 = {
  key: 1,
  class: "shadowBottom"
};
const _hoisted_3 = {
  key: 3
};
const _hoisted_4 = {
  class: "warp"
};
const _hoisted_5 = ["onClick"];
const _hoisted_6 = ["src"];
const _hoisted_7 = {
  class: "card-des"
};
const _hoisted_8 = {
  class: "mobileLine"
};
const _hoisted_9 = {
  class: "pcList"
};
const _hoisted_10 = {
  class: "swiper-container"
};
const _hoisted_11 = {
  class: "swiper-wrapper"
};
const _hoisted_12 = ["onClick"];
const _hoisted_13 = ["src"];
const _hoisted_14 = {
  class: "card-des"
};
const _hoisted_15 = {
  key: 0
};
const _hoisted_16 = {
  key: 1,
  class: "initialsPlaceholder"
};
const _hoisted_17 = ["onClick"];
const _hoisted_18 = ["src"];
const _hoisted_19 = {
  class: "num_bottom"
};
const _hoisted_20 = {
  key: 0,
  class: "noSearch"
};
const _hoisted_21 = ["onClick"];
const _hoisted_22 = {
  class: "pcLine"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", {
    class: _normalizeClass(`goldenCard ${$data.isPc ? 'isPc' : 'isMobile'}`)
  }, [_createElementVNode("div", {
    style: _normalizeStyle(`transform: scale(${$data.scale})`),
    class: "contentWarp"
  }, [$data.showSearch && !$data.isPc ? (_openBlock(), _createElementBlock("div", _hoisted_1)) : _createCommentVNode("", true), !$data.isPc ? (_openBlock(), _createElementBlock("div", _hoisted_2)) : _createCommentVNode("", true), !$data.showSearch && $data.isPc ? (_openBlock(), _createElementBlock("div", {
    key: 2,
    class: "pcTitle",
    style: _normalizeStyle(`margin-top: ${$data.pcTitleTop}px`)
  }, null, 4)) : _createCommentVNode("", true), !$data.isPc ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_createVNode(_Transition, {
    name: "fadeList"
  }, {
    default: _withCtx(() => [_withDirectives(_createElementVNode("div", {
      class: "photo_box",
      onTouchend: _cache[0] || (_cache[0] = (...args) => $options.touchend && $options.touchend(...args)),
      onTouchstart: _cache[1] || (_cache[1] = (...args) => $options.touchstart && $options.touchstart(...args)),
      onTouchmove: _cache[2] || (_cache[2] = (...args) => $options.touchmove && $options.touchmove(...args))
    }, [_createElementVNode("div", _hoisted_4, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.cardList, (item, index) => {
      return _withDirectives((_openBlock(), _createElementBlock("div", {
        class: _normalizeClass({
          card: true,
          cardMove: $data.moveParams.activeIndex == index && !$data.moveParams.moveDirection && $data.moveParams.move_x,
          cardEnd: $data.moveParams.activeIndex == index && $data.moveParams.moveDirection
        }),
        onClick: $event => $options.toUrl(item.itemformdata[5]),
        style: _normalizeStyle(`${$data.moveParams.activeIndex == index && !$data.moveParams.moveDirection && $data.moveParams.left_val ? `transform: rotateZ(${$data.moveParams.left_val < 0 ? '-10' : '10'}deg) translate3d(${$data.moveParams.left_val}px, ${$data.moveParams.top_val}px, 0px)` : ''} ${$data.moveParams.activeIndex == index && $data.moveParams.moveDirection ? `transform: rotateZ(${$data.moveParams.moveDirection < 0 ? '-30' : '30'}deg) translate3d(${$data.doc_width * $data.moveParams.moveDirection * 1.5}px, ${$data.moveParams.top_val * 2.2}px, 100px)` : ''}`)
      }, [_withDirectives(_createElementVNode("div", {
        class: "card-img",
        style: _normalizeStyle(`background: ${item.itemformdata[8] || '#724922'}`)
      }, [_createElementVNode("img", {
        src: item.itemformdata[7]
      }, null, 8, _hoisted_6), _createElementVNode("h1", null, _toDisplayString(item.itemformdata[1]), 1), _createElementVNode("p", null, _toDisplayString(item.itemformdata[4]), 1)], 4), [[_vShow, $data.moveParams.activeIndex == index || $data.moveParams.activeIndex + 1 == index && $data.moveParams.move_x]]), _withDirectives(_createElementVNode("div", _hoisted_7, [_createElementVNode("p", {
        class: _normalizeClass(item.itemformdata[9] ? 'point' : '')
      }, _toDisplayString(item.itemformdata[9]), 3), _createElementVNode("p", {
        class: _normalizeClass(item.itemformdata[10] ? 'point' : '')
      }, _toDisplayString(item.itemformdata[10]), 3)], 512), [[_vShow, $data.moveParams.activeIndex == index || $data.moveParams.activeIndex + 1 == index && $data.moveParams.move_x]])], 14, _hoisted_5)), [[_vShow, !item.hide]]);
    }), 256))])], 544), [[_vShow, !$data.showSearch]])]),
    _: 1
  })])) : _createCommentVNode("", true), _createElementVNode("div", {
    class: "searchWarp",
    style: _normalizeStyle($data.isPc && $data.showSearch ? 'margin-bottom: 38px;' : '')
  }, [$data.showSearch && $data.isPc ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: "backList",
    onClick: _cache[3] || (_cache[3] = (...args) => $options.cancelSearch && $options.cancelSearch(...args))
  }, "返回首页")) : _createCommentVNode("", true), _createElementVNode("i", {
    class: _normalizeClass(`icon-search ${$data.showSearch ? 'iconSearchLeft' : 'iconSearchRight'}`),
    onClick: _cache[4] || (_cache[4] = $event => $data.isPc ? '' : $data.showSearch = true)
  }, null, 2), _createElementVNode("div", {
    class: _normalizeClass(`searchLong ${!$data.showSearch ? 'hideSearchLong' : 'showSearchLong'}`)
  }, [_withDirectives(_createElementVNode("input", {
    type: "text",
    class: "search",
    placeholder: "请输入搜索内容",
    "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => $data.searchKey = $event)
  }, null, 512), [[_vModelText, $data.searchKey]]), $data.showSearch && !$data.isPc ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: "cancel",
    onClick: _cache[6] || (_cache[6] = (...args) => $options.cancelSearch && $options.cancelSearch(...args))
  }, "取消")) : _createCommentVNode("", true), $data.isPc ? (_openBlock(), _createElementBlock("div", {
    key: 1,
    class: "btn",
    onClick: _cache[7] || (_cache[7] = (...args) => $options.changeSearchKey && $options.changeSearchKey(...args))
  }, "搜索")) : _createCommentVNode("", true)], 2)], 4), _withDirectives(_createElementVNode("div", _hoisted_8, null, 512), [[_vShow, !$data.isPc && $data.showSearch]]), _withDirectives(_createElementVNode("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, [_createElementVNode("div", _hoisted_11, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.cardList, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      class: "swiper-slide card",
      onClick: $event => $options.toUrl(item.itemformdata[5])
    }, [_createElementVNode("div", {
      class: "card-img",
      style: _normalizeStyle(`background: ${item.itemformdata[8] || '#724922'}`)
    }, [_createElementVNode("img", {
      src: item.itemformdata[7]
    }, null, 8, _hoisted_13), _createElementVNode("h1", null, _toDisplayString(item.itemformdata[1]), 1), _createElementVNode("p", null, _toDisplayString(item.itemformdata[4]), 1)], 4), _createElementVNode("div", _hoisted_14, [_createElementVNode("p", {
      class: _normalizeClass(item.itemformdata[9] ? 'point' : '')
    }, _toDisplayString(item.itemformdata[9]), 3), _createElementVNode("p", {
      class: _normalizeClass(item.itemformdata[10] ? 'point' : '')
    }, _toDisplayString(item.itemformdata[10]), 3)])], 8, _hoisted_12);
  }), 256))]), _cache[9] || (_cache[9] = _createElementVNode("div", {
    class: "swiper-pagination"
  }, null, -1))])], 512), [[_vShow, $data.isPc && !$data.showSearch]]), _createElementVNode("div", {
    class: _normalizeClass(`searchList ${$data.showSearch ? 'showSearchList' : 'hideSearchList'}`),
    ref: "searchList",
    style: `top: 80px`
  }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.searchList, (item, index) => {
    return _openBlock(), _createElementBlock(_Fragment, null, [$data.isPc && (!$data.searchList[index - 1] || item.initial != $data.searchList[index - 1].initial) ? (_openBlock(), _createElementBlock("br", _hoisted_15)) : _createCommentVNode("", true), $data.isPc && (!$data.searchList[index - 1] || item.initial != $data.searchList[index - 1].initial) ? (_openBlock(), _createElementBlock("div", _hoisted_16, _toDisplayString(item.initial), 1)) : _createCommentVNode("", true), _createElementVNode("div", {
      class: "searchItem",
      ref_for: true,
      ref: `searchItem_${index}`,
      style: _normalizeStyle($data.isPc && (!$data.searchList[index - 1] || item.initial != $data.searchList[index - 1].initial) ? 'margin-top: 40px;' : ''),
      onClick: $event => $options.toUrl(item.itemformdata_s[5])
    }, [_createElementVNode("img", {
      src: item.itemformdata_s[3]
    }, null, 8, _hoisted_18), _createElementVNode("div", _hoisted_19, [_createElementVNode("div", null, _toDisplayString(item.itemformdata_s[1]), 1), _createElementVNode("div", null, _toDisplayString(item.itemformdata_s[4]), 1)])], 12, _hoisted_17)], 64);
  }), 256)), !$data.searchList.length ? (_openBlock(), _createElementBlock("div", _hoisted_20, "暂无数据")) : _createCommentVNode("", true)], 2), $data.showSearch ? (_openBlock(), _createElementBlock("div", {
    key: 4,
    class: _normalizeClass(`initials ${$data.showSearch ? 'showSearchList' : 'hideSearchList'}`)
  }, [_createElementVNode("ul", null, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(26, item => {
    return _createElementVNode("li", {
      onClick: $event => $options.handelInitials(item),
      class: _normalizeClass($data.initialsIndex == item - 1 ? 'activeInitlal' : '')
    }, _toDisplayString(String.fromCharCode(64 + item)), 11, _hoisted_21);
  }), 64)), _createElementVNode("li", {
    onClick: _cache[8] || (_cache[8] = $event => $options.handelInitials(27)),
    class: _normalizeClass($data.initialsIndex == 26 ? 'activeInitlal' : '')
  }, "#", 2)])], 2)) : _createCommentVNode("", true), _withDirectives(_createElementVNode("div", _hoisted_22, null, 512), [[_vShow, $data.isPc && $data.showSearch]])], 4)], 2);
}